import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import React__default, { forwardRef, Suspense } from 'react';
import { components } from 'react-select';
import { DropdownWrapper } from './Dropdown.styles.js';
import { OptionComponent } from '../Select/RSelectDerived.js';

const ReactSelect = React__default.lazy(() => import('react-select'));
const Dropdown = forwardRef((props, ref) => {
    const { onClick, options, toggleNode, externalProps } = props;
    return (jsx(Suspense, Object.assign({ fallback: null }, { children: jsx(DropdownWrapper, { children: jsx(ReactSelect, Object.assign({}, externalProps, { options: options, unstyled: true, isSearchable: false, classNamePrefix: "dropdown", className: "dropdown-main", onChange: (newOption) => {
                    (newOption === null || newOption === void 0 ? void 0 : newOption.onClick)
                        ? newOption === null || newOption === void 0 ? void 0 : newOption.onClick(newOption)
                        : onClick === null || onClick === void 0 ? void 0 : onClick(newOption);
                }, components: {
                    DropdownIndicator: (_a) => {
                        var localProps = __rest(_a, ["children"]);
                        return (jsx(components.DropdownIndicator, Object.assign({}, localProps, { children: toggleNode })));
                    },
                    Option: OptionComponent,
                }, controlShouldRenderValue: false, ref: ref, placeholder: "" })) }) })));
});

export { Dropdown as default };
//# sourceMappingURL=Dropdown.js.map
